import React from 'react'
import { connect } from 'react-redux'
import { startCase } from 'lodash'
import { Grid } from '@material-ui/core'
import { Email, Sms } from '@material-ui/icons'
import { FunnelStatComponent } from 'components/ListView/campaign'

export default connect(
	(state) => ({
		campaign: state.data?.campaign?.[state.campaign?.addOrEdit?.campaign?.id],
	}),
	null,
)(({ campaign }) => {
	const stats = campaign?.stats

	return (
		<div
			style={{
				backgroundColor: '#fff',
				border: '1px solid #aaa',
				padding: 20,
				borderRadius: 35,
				fontSize: 25,
			}}
		>
			{stats ? (
				<Grid container>
					{stats?.sms ? (
						<>
							<h5>Message stats</h5>
							{Object.keys(stats.sms).map((stat) => (
								<Grid
									item
									xs={12}
									// sm={12}
									// md={totalNumberOfStats > 6 ? 6 : 12}
								>
									<Sms
										style={{
											marginRight: 5,
											color: '#ccc',
											verticalAlign: 'middle',
											fontSize: 35,
										}}
									/>
									<span style={{ fontWeight: 500 }}>{`${startCase(
										`${stat?.split?.('_')?.[0]} text ${
											stat?.split?.('_')?.[1]
										}` || stat,
									)}: `}</span>
									{stats.sms[stat]}
								</Grid>
							))}
						</>
					) : null}
					{stats?.email
						? Object.keys(stats.email).map((stat) => (
								<Grid
									item
									xs={12}
									// sm={12}
									// md={totalNumberOfStats > 6 ? 6 : 12}
								>
									<Email
										style={{
											marginRight: 5,
											color: '#ccc',
											verticalAlign: 'middle',
											fontSize: 35,
										}}
									/>
									<span style={{ fontWeight: 500 }}>{`${startCase(
										`${stat?.split?.('_')?.[0]} email ${
											stat?.split?.('_')?.[1]
										}` || stat,
									)}: `}</span>
									{stats.email[stat]}
								</Grid>
						  ))
						: null}
				</Grid>
			) : (
				<div>No message stats for this campaign yet!</div>
			)}
			{campaign.status !== 'W' && (
				<div style={{ marginTop: 10 }}>
					<h5>Funnel Stats</h5>
					<FunnelStatComponent statsPage campaign={campaign} />
				</div>
			)}
		</div>
	)
})
